import * as React from "react";
const SvgFiBrandsCreativeCommonsBy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons-by_svg__a)">
      <path
        fill="#151A2D"
        d="M12.478 0q5.268 0 8.884 3.472Q25 6.964 25 12q0 5.058-3.572 8.421Q17.634 24 12.478 24q-5.067 0-8.795-3.536Q0 16.929 0 12t3.683-8.528Q7.298 0 12.478 0m.044 2.164q-4.264 0-7.21 2.871-3.057 3-3.058 6.964 0 3.985 3.036 6.9 3.036 2.914 7.232 2.914 4.173 0 7.277-2.936 2.947-2.721 2.947-6.879 0-4.093-2.99-6.964-2.993-2.869-7.234-2.87m3.349 6.858v4.907h-1.428v5.828h-3.885v-5.828H9.13V9.022q0-.32.235-.547a.8.8 0 0 1 .57-.225h5.134q.311 0 .558.225.245.225.245.547m-5.112-3.086q0-1.692 1.741-1.693 1.741 0 1.742 1.693 0 1.671-1.742 1.671t-1.74-1.671"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-by_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsBy;
